.hero {
  position: relative;
  background: var(--color-primary-blue-100); /* blue-100 (soft blue hero wash) */
  padding: 60px 0 66px;
  overflow: hidden;
}

/* 6px accent (yellow) bottom rule, as in the design */
.hero::after {
  content: '';
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  height: 6px;
  background: var(--color-complementary-yellow); /* COMPLEMENTARY_YELLOW (accent) */
}

.hero__inner {
  position: relative;
  display: grid;
  grid-template-columns: 1.15fr 1fr;
  align-items: center;
  gap: 52px;
}

/* let both tracks shrink below content so a wide image/long word can't blow out the grid */
.hero__text,
.hero__art {
  min-width: 0;
}

.hero__breadcrumb {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 11px; /* COPY_XS */
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  color: var(--color-text-tertiary); /* text-3 */
  margin-bottom: 30px;
}

.hero__breadcrumbTag {
  background: var(--color-primary-blue-900); /* PRIMARY_BLUE_900 */
  color: var(--color-primary-grey-000);
  padding: 5px 13px;
  border-radius: 9999px;
  letter-spacing: 0.06em;
}

.hero__title {
  font-family: var(--plume-font-display, sofia-pro, sans-serif);
  font-weight: 900;
  font-size: clamp(44px, 6vw, 80px);
  line-height: 1.1;
  letter-spacing: -0.015em;
  color: var(--color-primary-grey-900); /* PRIMARY_GREY_900 */
  margin: 0 0 40px;
  text-wrap: balance;
}

.hero__titleHighlight {
  color: var(--color-primary-red-500); /* PRIMARY_RED_500 */
  font-style: italic;
}

.hero__lede {
  font-size: 19px; /* HEADING_XS */
  line-height: 1.55;
  color: var(--color-primary-sand-900); /* PRIMARY_SAND_900 (text-2) */
  max-width: 42ch;
  margin: 0 0 34px;
}

.hero__actions {
  display: flex;
  flex-wrap: wrap;
  gap: 14px;
}

/* Bare hero illustration: fills its column and scales with it — fully visible at every width
   (matches the Press hero; no frame, no fixed bleed that would crop the group on narrow screens). */
.hero__image {
  display: block;
  width: 100%;
  max-width: 100%;
  height: auto;
}

@media (max-width: 860px) {
  .hero__inner {
    grid-template-columns: 1fr;
  }

  /* drop the illustration on narrow screens, same as the Press hero */
  .hero__art {
    display: none;
  }
}
